export const version = '1.0.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'transparent'
};
export const userInfo = {
  userId: -1,
  userName: '',
  userEmail: '',
  user: null,
  remember: false,
  integrations: {},
  providers: {},
  permissions: [],
  company: null,
  companies: [],
  profile: null,
  membership: null,
  activeIntegration: null,
  workspace: {
    mode: 'gestion',
    label: 'Gestion',
    partner_code: '',
    partner_label: ''
  },
}

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings, userInfo };
